"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextElementStyled = void 0;
var _styled_1 = require("./");
var _helpers_1 = require("../helpers");
var styled_components_1 = __importDefault(require("styled-components"));
exports.TextElementStyled = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  a {\n    color: ", ";\n  }\n  span {\n    display: inline-block;\n    border-bottom: ", ";\n    font-weight: ", ";\n    padding-bottom: 0px;\n    margin: 0;\n    line-height: ", ";\n    color: ", ";\n  }\n\n  @media (max-width: ", ") {\n  }\n  @media (max-width: ", ") {\n  }\n"], ["\n  color: ",
    ";\n  a {\n    color: ",
    ";\n  }\n  span {\n    display: inline-block;\n    border-bottom: ",
    ";\n    font-weight: ", ";\n    padding-bottom: 0px;\n    margin: 0;\n    line-height: ", ";\n    color: ",
    ";\n  }\n\n  @media (max-width: ", ") {\n  }\n  @media (max-width: ", ") {\n  }\n"])), function (_a) {
    var _b;
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme, as = _a.as;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor((_b = dark.fullHd) !== null && _b !== void 0 ? _b : dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme, as)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme, as);
    return color ? color + " !important" : '';
}, function (_a) {
    var _b;
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme, as = _a.as;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor((_b = dark.fullHd) !== null && _b !== void 0 ? _b : dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme, as)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme, as);
    return color ? color + " !important" : '';
}, function (_a) {
    var theme = _a.theme, spanConfig = _a.spanConfig;
    return (spanConfig === null || spanConfig === void 0 ? void 0 : spanConfig.borderBottom) || "3px solid " + theme.primary;
}, function (_a) {
    var spanConfig = _a.spanConfig;
    return (spanConfig === null || spanConfig === void 0 ? void 0 : spanConfig.fontWeight) || 'inherit';
}, function (_a) {
    var defaultCss = _a.defaultCss;
    return defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.lineHeight;
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme, as = _a.as;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme, as);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme, as);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointTablet;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var templateObject_1;
//# sourceMappingURL=TextElementStyled.js.map